/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const data_source = {
  url: 'https://proyectosdesarrollo.com:17998/',
  token:null
};

//https://proyectosdesarrollo.com:18000/
